import React from 'react';
import { Route, Switch, NavLink } from 'react-router-dom';
import ModalEnabledComponent from '../extend/ModalEnabled';

import MenuManagerWeekly from '../menus/MenusWeekly';
import MenuManagerOccasion from '../menus/MenusOccasion';
import MenuManagerEvergreen from '../menus/MenusEvergreen';
import MenuManagerCompany from '../menus/MenusCompany';
import MenuManagerArchived from '../menus/MenusArchived';

import MenusCreateModal from '../menus/MenusCreateModal';
import withTracker from '../withTracker';

class AdminMenus extends ModalEnabledComponent {
  render() {
    const { openModal, closeModal, isOpen } = this;

    return (
      <div className="menus cms">
        <div className="cms__head">
          <div className="cms__content">
            <div className="cms__bar cms__head--padding">
              <div className="cms__bar-left">
                <h1 className="h2">Menu Library</h1>
              </div>
              <div className="cms__bar-right">
                <div
                  className="btn btn--solid-blue"
                  onClick={() => openModal('new')}
                >
                  Create a New Menu
                </div>
              </div>
            </div>
            <div className="tabs">
              <NavLink className="tab" to="/admin/menus/weekly">
                Weekly
              </NavLink>
              <NavLink className="tab" to="/admin/menus/evergreen">
                Evergreen
              </NavLink>
              <NavLink className="tab" to="/admin/menus/occasion">
                Occasion
              </NavLink>
              <NavLink className="tab" to="/admin/menus/company">
                Company
              </NavLink>
              <NavLink className="tab" to="/admin/menus/archived">
                Archived
              </NavLink>
            </div>
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <Switch>
              <Route
                path="/admin/menus/weekly"
                component={MenuManagerWeekly}
              />
              <Route
                path="/admin/menus/evergreen"
                component={MenuManagerEvergreen}
              />
              <Route
                path="/admin/menus/occasion"
                component={MenuManagerOccasion}
              />
              <Route
                path="/admin/menus/company"
                component={MenuManagerCompany}
              />
              <Route
                path="/admin/menus/archived"
                component={MenuManagerArchived}
              />
            </Switch>
          </div>
        </div>

        <MenusCreateModal isOpen={isOpen('new')} closeModal={closeModal} />
      </div>
    );
  }
}

export default withTracker(AdminMenus);



// WEBPACK FOOTER //
// ./src/components/admin/AdminMenus.js